
export const profiles = {
  title: 'Perfis de Personalidade',
  subtitle: 'Descubra os 19 perfis únicos de personalidade e entenda como cada tipo aborda o trabalho, comunicação e colaboração.',
  exampleChart: 'Exemplo de Perfil',
  patternCode: 'Código de Padrão',
  seeAllProfiles: 'Ver Todos os Perfis',
  backToAssessment: 'Fazer Avaliação',
  averageScores: 'Pontuações Médias',
  basedOnAssessments: 'Baseado em {{count}} avaliações',
  exampleData: 'Dados de exemplo',
  contributors: {
    title: 'Contribuintes ({{count}})',
    andMore: 'e mais {{count}}...'
  }
};
